import BulkManageDesktop from "common/components/BulkManageDesktop";

import { MANAGE_AUDIENCE_ACTIONS } from "../../../../../constants";
import ExportTargets from "../../../ManageAudience/ExportTargets";
import RemoveTargets from "../../../ManageAudience/RemoveTargets";

import type { AudienceFilters, AudienceProfile } from "../../../../../types";

interface ManageDesktopAudienceProps {
  selectedTargets: AudienceProfile[];
  resetSelectedTargets: () => void;
  filters?: AudienceFilters;
}

export default function ManageDesktopAudience({
  selectedTargets,
  resetSelectedTargets,
  filters,
}: ManageDesktopAudienceProps) {
  return (
    <BulkManageDesktop
      actions={MANAGE_AUDIENCE_ACTIONS}
      selection={selectedTargets}
      renderActionComponent={({ action, onClose }) => {
        const props = {
          selectedTargets,
          onBack: onClose,
          onSuccess: () => {
            onClose();
            resetSelectedTargets();
          },
          filters,
        };

        if (action === "export") {
          return <ExportTargets {...props} />;
        }
        if (action === "remove") {
          return <RemoveTargets {...props} />;
        }
      }}
    />
  );
}
